import Icon, { IconColor, IconType } from '../../various/Icon';

export const SelectionImportLoader = () => <Icon type={IconType.Spinner} color={IconColor.Blue} size={32} />;
